var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueExclamationCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02891 0 0 4.02891 0 9C0 13.9711 4.02891 18 9 18C13.9711 18 18 13.9711 18 9C18 4.02891 13.9711 0 9 0ZM8.15625 5.34375C8.15625 4.87969 8.53594 4.5 9 4.5C9.46406 4.5 9.84375 4.87793 9.84375 5.34375V9.84375C9.84375 10.3096 9.46582 10.6875 9 10.6875C8.53418 10.6875 8.15625 10.3113 8.15625 9.84375V5.34375ZM9 14.0625C8.38969 14.0625 7.89469 13.5675 7.89469 12.9572C7.89469 12.3469 8.38934 11.8519 9 11.8519C9.61066 11.8519 10.1053 12.3469 10.1053 12.9572C10.1039 13.5668 9.61172 14.0625 9 14.0625Z",
    fill: "#236CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueExclamationCircle);
export default __webpack_public_path__ + "static/media/blueExclamationCircle.2996dc0cf45836fdd5a4248bd21cc60e.svg";
export { ForwardRef as ReactComponent };